if(!window.SKULL_PROMO_SERVICE){
 window.SKULL_PROMO_SERVICE=true;window.SBShippingInsuranceReady=true;window.__skullPromoGiftsGlobalLoaded=true;
 const INSURANCE=68074549084388,LEGACY_INSURANCE=[68074528473316],GIFTS=[{id:45998998290660,min:8},{id:49234202001636,min:12}],EXCLUDED=new Set([INSURANCE,...LEGACY_INSURANCE,...GIFTS.map(g=>g.id)]);
 // Match Shopify automatic 4x1 eligibility; accessories and automatic extras never advance it.
 const PROMO_PRODUCTS=new Set([8907956781284,9059424174308,9059571630308]);
 const promoQuantity=items=>items.reduce((count,item)=>{
  const p=item.properties||{},isGift=[p._skull_gift,p._skull_auto_gift].some(v=>v===true||v==='true'||v==='1');
  return count+(PROMO_PRODUCTS.has(Number(item.product_id))&&!isGift&&p._tipo!=='Seguro de envío'?Number(item.quantity)||0:0);
 },0);
 const fetchCart=window.fetch.bind(window),root=window.Shopify?.routes?.root||'/',declinedKey='sb_shipping_insurance_declined';
 const sound=new Audio('https://cdn.shopify.com/s/files/1/0602/8270/0004/files/skullmx.mp3?v=1780031728');sound.preload='none';
 let syncing=null,timer,dirty=false,lastSound=0;
 const declined=()=>{try{return localStorage.getItem(declinedKey)==='1';}catch{return window.SKULL_INSURANCE_DECLINED===true;}};
 const connectionError='No pudimos actualizar tu carrito. Espera unos segundos e inténtalo de nuevo.';
 async function json(path,body){
  const fail=(message,status)=>Object.assign(Error(message),{path,status});
  // Retry only reads: replaying a product add could duplicate a successful request.
  for(let attempt=0;attempt<2;attempt++){
   let response;
   try{response=await fetchCart(root+path,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(10000),...(body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{})});}
   catch(error){throw fail(error.name==='TimeoutError'?'La conexión está tardando. Inténtalo de nuevo.':connectionError);}
   if(!body&&!attempt&&(response.status===429||response.status>=500)){await new Promise(resolve=>setTimeout(resolve,600));continue;}
   let data;try{data=await response.json();}catch{throw fail(connectionError,response.status);}
   if(!response.ok)throw fail(data.description||data.message||connectionError,response.status);return data;
  }
 }
 async function reconcile(){
  let cart=await json('cart.js');
  const normalCount=cart.items.filter(i=>!EXCLUDED.has(i.variant_id)).reduce((n,i)=>n+i.quantity,0),count=promoQuantity(cart.items);
  const targets=[...LEGACY_INSURANCE.map(id=>({id,wanted:false,properties:{}})),{id:INSURANCE,wanted:normalCount>0&&!declined(),properties:{_tipo:'Seguro de envío',_cobertura:'Pérdida, robo o daño'}},...GIFTS.map(g=>({id:g.id,wanted:count>=g.min,properties:{_skull_gift:'true',_skull_auto_gift:'true',_skull_milestone:String(g.min)}}))];
  const updates={},additions=[];
  for(const target of targets){
   const existing=cart.items.filter(i=>i.variant_id===target.id);
   if(target.wanted&&!existing.length)additions.push(target);
   existing.forEach((item,index)=>{const quantity=target.wanted&&index===0?1:0;if(item.quantity!==quantity)updates[item.key]=quantity;});
  }
  if(Object.keys(updates).length)cart=await json('cart/update.js',{updates});
  const warnings=[];
  // Automatic extras must not prevent payment when an item is unavailable.
  for(const target of additions){
   try{await json('cart/add.js',{items:[{id:target.id,quantity:1,properties:target.properties}]});}
   catch(error){if(error.status!==422)throw error;warnings.push(target.id===INSURANCE?'No pudimos agregar el envío protegido. Puedes continuar al pago.':'Un regalo de la promoción está agotado. Puedes continuar al pago.');}
  }
  if(additions.length)cart=await json('cart.js');return {cart,notice:[...new Set(warnings)].join(' ')};
 }
 async function sync(){
  clearTimeout(timer);
  // A caller waiting for the same state must not request another full sync.
  if(syncing)return syncing;
  syncing=(async()=>{
   let cart,passes=0;
   do{
    dirty=false;const result=await reconcile();cart=result.cart;window.SKULL_PROMO_NOTICE=result.notice;
    window.__SKULL_CART=cart;window.SKULL_CART_UPDATE?.(cart,true);
    document.dispatchEvent(new CustomEvent('skull:cart-synced',{detail:{cart}}));
   }while(dirty&&++passes<3);
   return cart;
  })().catch(error=>{
   console.warn('[SKULL promos]',error);document.dispatchEvent(new CustomEvent('skull:promo-error',{detail:{message:error.message}}));throw error;
  }).finally(()=>{syncing=null;if(dirty)schedule();});
  return syncing;
 }
 function schedule(){dirty=true;clearTimeout(timer);timer=setTimeout(()=>{sync().catch(()=>{});},160);}
 window.SKULL_PROMO_SYNC=sync;
 window.SKULL_INSURANCE_TOGGLE=async checked=>{
  window.SKULL_INSURANCE_DECLINED=!checked;
  try{checked?localStorage.removeItem(declinedKey):localStorage.setItem(declinedKey,'1');}catch{}
  // Persist a change made while another sync is already running.
  dirty=true;return sync();
 };
 window.fetch=async function(request,options){
  const response=await fetchCart(request,options),url=typeof request==='string'?request:request?.url||'';
  if(response.ok&&/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)){
   schedule();if(/\/cart\/add/.test(url)&&Date.now()-lastSound>900){lastSound=Date.now();sound.play().catch(()=>{});}
  }
  return response;
 };
 document.addEventListener('change',event=>{if(event.target.matches('[data-sb-insurance-checkbox]'))window.SKULL_INSURANCE_TOGGLE(event.target.checked).catch(()=>{});});
 json('variants/'+INSURANCE+'.js').then(variant=>{window.SKULL_INSURANCE_PRICE=variant.price;document.dispatchEvent(new CustomEvent('skull:insurance-price'));}).catch(()=>{});
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});schedule();
}
